// extracted by mini-css-extract-plugin
module.exports = {"dark-blue":"style_dark-blue__tQRoG"};